<template>
  <div id="brief_app">
    <div @click="enabled = false" :class="{ 'modal-estimate': enabled }">
      <div class="estimation_modal" v-if="enabled">
        <div @click.stop="" class="modal_inner">

          <div class="modal_header">
            <img :src="content.logo" :alt="logoDescription" class="company_logo">
            <button class="close_modal" @click="closeModalOnMouse">✖</button>
          </div>

          <div class="modal_body">
            <div class="body_left">
              <form
                class="estimation_form"
                @submit.prevent=""
                novalidate="true"
              >
                <h1 class="title">{{ estimateProject }}</h1>
                <div class="form_body">
                  <div
                    :class="{ 'input_error': errors.name }"
                    class="input_wrapper"
                  >
                    <input
                      v-model="name"
                      type="text"
                      class="form_field"
                      :placeholder="errors.name ? nameInvalid : namePlaceholder"
                      :disabled="sending || success"
                    >
                  </div>

                  <div
                    :class="{ 'input_error': errors.email }"
                    class="input_wrapper"
                  >
                    <input
                      v-model="email"
                      type="email"
                      class="form_field"
                      :placeholder="errors.email ? emailInvalid : emailPlaceholder"
                      :disabled="sending || success"
                    >
                  </div>

                  <div
                    :class="{ 'input_error': errors.tel }"
                    class="input_wrapper"
                  >
                    <input
                      v-model="tel"
                      type="tel"
                      class="form_field"
                      :placeholder="errors.tel ? phoneInvalid : phonePlaceholder"
                      :disabled="sending || success"
                    >
                  </div>

                  <div
                    :class="{ 'input_error': errors.description }"
                    class="input_wrapper"
                  >
                    <textarea
                      v-model="description"
                      class="form_field form_textarea"
                      :class="{ 'form_field_textarea': 1, 'input_error': errors.description }"
                      :placeholder="errors.description ? descriptionInvalid : descriptionPlaceholder"
                      :disabled="sending || success"
                    >
                    </textarea>
                  </div>

                  <div
                    :class="{ 'input_error': errors.rodo }"
                    class="input_wrapper input_wrapper_checkbox"
                  >
                    <input
                      id="rodo"
                      v-model="rodo"
                      type="checkbox"
                      :class="{ 'input_checkbox': 1, 'input_checkbox--error': errors.rodo }"
                      :disabled="sending || success"
                    >
                    <label
                      for="rodo"
                      :class="{ 'input_checkbox_label': 1, 'input_checkbox_label--disabled': sending || success }"
                    >
                      {{ rodoPlaceholder }}
                    </label>
                    <div
                      :class="{ 'input_checkbox_error-box': 1, 'hidden': !errors.rodo }"
                    >
                      <p>
                        {{ rodoInvalid }}
                      </p>
                    </div>
                  </div>

                  <div class="sending_wrap">
                    <div class="recaptcha">
                      <vue-recaptcha
                        :sitekey="content.captcha"
                        @verify="reCaptchaVerified = true"
                        @expired="reCaptchaVerified = false"
                      >
                      </vue-recaptcha>

                      <div v-if="errors.captcha" class="input_error">{{ captchaError }}</div>
                    </div>

                    <div class="submit_wrap">
                    <input
                      type="submit"
                      id="estimate_form_send"
                      :value="submitForm"
                      :class="{ 'processing': sending, 'brief_submit': true }"
                      :disabled="sending || success"
                      @click="validateFields"
                    >
                    </div>

                  </div>
                  <div class="sending-info" v-if="sending">{{ sendingInfo }}</div>
                </div>
              </form>
            </div>

            <div class="body_right" :class="{'success': success, 'error': errored}">
              <div class="background-svg">
                <svg version="1.0" xmlns="http://www.w3.org/2000/svg"
                width="1734.000000pt" height="950.000000pt" viewBox="0 0 1734.000000 950.000000"
                preserveAspectRatio="xMidYMid meet">
                  <g transform="translate(0.000000,950.000000) scale(0.100000,-0.100000)" stroke="none">
                    <path d="M4005 9494 c-22 -2 -89 -9 -150 -14 -684 -65 -1420 -372 -2075 -866
                    -430 -324 -804 -729 -1080 -1168 -84 -136 -262 -480 -330 -641 -130 -306 -236
                    -681 -295 -1037 -56 -341 -75 -664 -63 -1058 43 -1440 698 -2867 1588 -3462
                    119 -80 362 -202 495 -248 390 -136 827 -170 1285 -100 485 74 914 214 1834
                    599 187 78 418 174 515 213 777 311 1230 419 1816 435 874 23 1761 -229 2853
                    -812 293 -156 552 -304 1009 -576 590 -351 951 -510 1423 -628 344 -87 631
                    -122 985 -122 261 0 449 15 668 56 965 178 1770 745 2299 1619 89 147 248 463
                    306 611 157 398 237 778 249 1191 15 528 -79 968 -301 1409 -306 606 -831
                    1097 -1526 1428 -390 186 -783 283 -1285 318 -189 13 -812 7 -1050 -10 -772
                    -57 -1416 -76 -1761 -52 -616 43 -1174 208 -1872 556 -391 195 -640 340 -1437
                    835 -742 461 -975 597 -1375 803 -780 402 -1439 626 -2070 702 -127 15 -564
                    28 -655 19z" />
                  </g>
                </svg>
              </div>
              <!-- three states
                sending # hide everything when sending
                success # show success message
                error # show error message
              -->
              <transition name="fade">
                <template>
                  <div class="request_content">
                    <template v-if="success">
                      <div class="body_header">
                        <div class="title" v-html="successHeader"></div>
                      </div>
                      <div class="body_footer">
                        <p v-html="successFooter"></p>
                        <p class="popup-close-message"><span v-html="popupCloseMessage"></span><span v-html="popupCloseCountdown"></span><span>s ...</span></p>
                      </div>
                    </template>

                    <template v-if="errored">
                      <div class="body_header">
                        <div class="title" v-html="errorHeader"></div>
                      </div>
                    </template>

                    <template v-if="!success && !errored">
                      <div class="body_header">
                        <div class="definition back_in_24">
                          <div class="icon">
                            <div class="media">
                              <svg version="1.1" id="Layer_1" xmlns:x="&ns_extend;" xmlns:i="&ns_ai;" xmlns:graph="&ns_graphs;"
                                xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 192 192"
                                enable-background="new 0 0 192 192" xml:space="preserve">
                                <g>
                                  <path d="M92.5,120.5H69.4c2.1-3.4,6.4-7.3,10.2-10.9c7.5-6.8,15.2-13.9,15.2-22.4c0-10.7-8.7-17.1-17.1-17.1
                                  c-8.6,0-18.6,4.9-18.6,18.6c0,2.1,1.7,3.8,3.8,3.8c2.1,0,3.8-1.7,3.8-3.8c0-10,7.7-11.1,11.1-11.1c4,0,9.6,3,9.6,9.6
                                  c0,5.2-6.8,11.4-12.7,16.9c-7.2,6.6-14,12.8-14,20.2v3.8h32c2.1,0,3.8-1.7,3.8-3.8C96.3,122.2,94.6,120.5,92.5,120.5z"/>
                                  <path d="M133.6,105.4h-7.5v-32c0-1.7-1.1-3.1-2.7-3.6c-1.6-0.5-3.3,0.2-4.2,1.6l-22.6,35.8c-0.7,1.2-0.8,2.6-0.1,3.8
                                  c0.7,1.2,1.9,1.9,3.3,1.9h18.8v11.3c0,2.1,1.7,3.8,3.8,3.8c2.1,0,3.8-1.7,3.8-3.8v-11.3h7.5c2.1,0,3.8-1.7,3.8-3.8
                                  S135.7,105.4,133.6,105.4z M118.6,105.4h-12l12-19V105.4z"/>
                                  <path d="M186.4,90.4c-3.1,0-5.6,2.5-5.6,5.6c0,46.7-38,84.7-84.7,84.7s-84.7-38-84.7-84.7s38-84.7,84.7-84.7
                                  c19,0,36.9,6.1,51.8,17.7c2.5,1.9,6,1.5,7.9-1s1.5-6-1-7.9C137.8,6.9,117.5,0,96,0C43.1,0,0,43.1,0,96c0,52.9,43.1,96,96,96
                                  s96-43.1,96-96C192,92.9,189.5,90.4,186.4,90.4z"/>
                                  <path d="M160,1.6c-3.1,0-5.6,2.5-5.6,5.6v21h-20.7c-3.1,0-5.6,2.5-5.6,5.6c0,3.1,2.5,5.6,5.6,5.6H160c3.1,0,5.6-2.5,5.6-5.6V7.3
                                  C165.6,4.1,163.1,1.6,160,1.6z"/>
                                </g>
                              </svg>
                            </div>
                          </div>
                          <p class="title" v-html="defaultIconOne"></p>
                        </div>

                        <div class="definition prep_estimation">
                          <div class="icon">
                            <div class="media">
                              <svg height="512pt" viewBox="0 0 512 512" width="512pt" xmlns="http://www.w3.org/2000/svg">
                                <path d="m341.4375.214844h-302.679688c-21.371093 0-38.757812 17.386718-38.757812 38.753906v406.488281c0 36.691407 29.851562 66.542969
                                66.542969 66.542969h247.105469c36.691406 0 66.542968-29.851562 66.542968-66.542969v-406.488281c0-21.367188-17.386718-38.753906-38.753906-38.753906zm0
                                30c4.828125 0 8.753906 3.925781 8.753906 8.753906v10.671875h-96.328125v-19.425781zm-117.574219 0v19.425781h-67.535156v-19.425781zm-67.535156
                                49.425781h67.535156v19.144531c0 .476563-.386719.863282-.863281.863282h-65.808594c-.472656 0-.859375-.386719-.859375-.863282v-19.144531zm-117.570313
                                -49.425781h87.570313v19.425781h-96.328125v-10.671875c0-4.828125 3.929688-8.753906 8.757812-8.753906zm274.890626 451.785156h-247.105469c-20.148438
                                0-36.542969-16.394531-36.542969-36.542969v-365.816406h96.328125v19.144531c0 17.019532 13.847656 30.863282 30.863281 30.863282h65.808594c17.019531
                                0 30.863281-13.84375 30.863281-30.863282v-19.144531h96.328125v365.816406c0 20.148438-16.390625 36.542969-36.542968 36.542969zm0 0"/>
                                <path d="m228.570312 172.957031h-160.324218c-8.28125 0-15 6.71875-15 15 0 8.285157 6.71875 15 15 15h160.324218c8.285157 0 15-6.714843 15-15 0-8.28125-6.714843-15-15-15zm0 0"/>
                                <path d="m311.945312 172.957031h-27.710937c-8.285156 0-15 6.71875-15 15 0 8.285157 6.714844 15 15 15h27.710937c8.285157 0 15-6.714843 15-15 0-8.28125-6.714843-15-15-15zm0 0"/>
                                <path d="m68.246094 262.9375h73.082031c8.285156 0 15-6.714844 15-15s-6.714844-15-15-15h-73.082031c-8.28125 0-15 6.714844-15 15s6.714844 15 15 15zm0 0"/>
                                <path d="m311.945312 232.9375h-27.710937c-8.285156 0-15 6.714844-15 15s6.714844 15 15 15h27.710937c8.285157 0 15-6.714844 15-15s-6.714843-15-15-15zm0 0"/>
                                <path d="m228.570312 292.808594h-160.324218c-8.28125 0-15 6.714844-15 15s6.71875 15 15 15h160.324218c8.285157 0 15-6.714844 15-15s-6.714843-15-15-15zm0 0"/>
                                <path d="m311.945312 292.808594h-27.710937c-8.285156 0-15 6.714844-15 15s6.714844 15 15 15h27.710937c8.285157 0 15-6.714844 15-15s-6.714843-15-15-15zm0 0"/>
                                <path d="m204.367188 352.785156h-136.121094c-8.28125 0-15 6.71875-15 15 0 8.285156 6.71875 15 15 15h136.121094c8.285156 0 15-6.714844 15-15 0-8.28125-6.714844-15-15-15zm0 0"/>
                                <path d="m311.945312 352.785156h-27.710937c-8.285156 0-15 6.71875-15 15 0 8.285156 6.714844 15 15 15h27.710937c8.285157 0 15-6.714844 15-15 0-8.28125-6.714843-15-15-15zm0 0"/>
                                <path d="m141.328125 411.058594h-73.082031c-8.28125 0-15 6.714844-15 15s6.71875 15 15 15h73.082031c8.285156 0 15-6.714844 15-15s-6.714844-15-15-15zm0 0"/>
                                <path d="m311.945312 411.058594h-27.710937c-8.285156 0-15 6.714844-15 15s6.714844 15 15 15h27.710937c8.285157 0 15-6.714844 15-15s-6.714843-15-15-15zm0 0"/>
                                <path d="m480.425781 40.359375h-3.089843v-25.359375c0-8.285156-6.714844-15-15-15-8.28125 0-15 6.714844-15 15v25.359375h-3.089844c-17.40625 0-31.570313 14.15625-31.570313
                                31.554687v320.527344c0 31.113282 12.550781 60.75 34.660157 82.367188v22.191406c0 8.285156 6.71875 15 15 15 8.285156 0 15-6.714844 15-15v-22.1875c22.113281-21.621094
                                34.664062-51.257812 34.664062-82.371094v-320.527344c0-17.398437-14.164062-31.554687-31.574219-31.554687zm-37.753906 79.519531h39.328125v149.929688h-39.328125zm1.574219
                                -49.519531h36.179687c.867188 0 1.574219.699219 1.574219 1.554687v17.964844h-39.328125v-17.964844c0-.855468.707031-1.554687 1.574219-1.554687zm18.089844 376.523437c
                                -12.621094-15.1875-19.664063-34.398437-19.664063-54.441406v-92.632812h39.328125v92.632812c0 20.039063-7.042969 39.253906-19.664062 54.441406zm0 0"/>
                              </svg>
                            </div>
                          </div>
                          <p class="title" v-html="defaultIconTwo"></p>
                        </div>

                        <div class="definition code_review">
                          <div class="icon">
                            <div class="media">
                              <svg height="512pt" viewBox="0 -16 512 512" width="512pt" xmlns="http://www.w3.org/2000/svg"><path d="m507.605469 325.726562-69.726563-69.726562 1.453125-1.453125c16.910157-16.90625 16.914063-44.417969.023438-61.335937-.019531-.019532-.039063-.039063-.058594-.058594-4.179687-4.175782-9.0625-7.394532-14.378906-9.542969 4.605469-11.648437 5.605469-31.363281-9.6875-46.65625-.039063-.039063-.078125-.078125-.121094-.121094-4.160156-4.132812-9.011719-7.320312-14.292969-9.457031 4.597656-11.628906 5.601563-31.359375-9.675781-46.644531-.011719-.007813-.019531-.019531-.027344-.027344-4.183593-4.183594-9.070312-7.40625-14.394531-9.5625 1.980469-5.019531 3.019531-10.414063 3.019531-15.972656 0-11.589844-4.515625-22.484375-12.707031-30.679688-.003906-.003906-.003906-.007812-.007812-.007812-.003907-.003907-.007813-.007813-.011719-.011719-16.917969-16.917969-44.445313-16.917969-61.363281 0l-1.449219 1.453125-21.527344-21.527344c-4.5625-4.566406-11.542969-5.695312-17.3125-2.8125l-54.902344 27.453125c-16.808593-13.226562-41.5-12.414062-57.378906 3.410156-.027344.023438-.050781.050782-.078125.074219-3.632812 3.632813-15.152344 16.539063-12.265625 36.867188-7.277344 1.863281-14.164063 5.628906-19.847656 11.3125-.003907.007812-.011719.011719-.015625.015625 0 .003906 0 .003906-.003906.003906-15.273438 15.273438-14.316407 34.917969-9.671876 46.65625-5.289062 2.136719-10.148437 5.324219-14.3125 9.460938-.039062.039062-.078124.078124-.117187.117187-15.269531 15.273437-14.3125 34.917969-9.671875 46.65625-5.316406 2.148437-10.203125 5.359375-14.382812 9.535156-.027344.023438-.050782.046875-.074219.074219-16.914063 16.949219-16.929688 44.367188.03125 61.328125l1.453125 1.453125-69.726563 69.726562c-5.859375 5.859376-5.859375 15.355469 0 21.214844 5.855469 5.859375 15.355469 5.855469 21.210938 0l73.421875-73.421875c11.101562 3.289063 28.976562 3.15625 43.054687-10.921875.023438-.023437.050781-.050781.074219-.078125 7.421875-7.445312 11.796875-17.113281 12.527344-27.5 10.414062-.734375 20.109375-5.132812 27.5625-12.585937.003906-.003906.007812-.007813.011718-.011719.003907-.003906.003907-.003906.007813-.007813 7.460937-7.460937 11.855469-17.164062 12.585937-27.585937 10.039063-.714844 19.875-4.886719 27.535157-12.539063.027343-.023437.050781-.046874.074219-.070312 7.648437-7.664062 11.816406-17.496094 12.535156-27.53125 10.410156-.730469 20.101562-5.117188 27.5625-12.566406.023437-.023438.046875-.046875.066406-.070313 14.042969-14.066406 14.191406-31.886719 10.894531-43.023437l53.347657-53.347656c5.21875-5.21875 13.714843-5.21875 18.933593 0 .007813.007812.011719.011718.019531.019531 5.230469 5.230469 5.234376 13.699219 0 18.933593l-35.792968 35.792969c-5.859375 5.859375-5.859375 15.355469 0 21.214844 5.855468 5.855469 15.351562 5.859375 21.210937 0l19.785157-19.78125c5.230468-5.171875 13.652343-5.164063 18.871093.046875.011719.011719.023438.023438.035157.035156 5.21875 5.226563 5.222656 13.691406-.011719 18.925782l-28.125 28.125c-5.855469 5.859374-5.855469 15.355468 0 21.214843 5.859375 5.859375 15.355469 5.855469 21.214843 0l12.058594-12.058593c5.230469-5.230469 13.699219-5.238282 18.933594 0 .027344.027343.054688.050781.082031.078124 5.164063 5.230469 5.15625 13.65625-.0625 18.875l-28.125 28.125c-5.855469 5.855469-5.859375 15.355469 0 21.214844 5.855469 5.855469 15.355469 5.855469 21.214844 0l12.101563-12.105468c5.234374-5.183594 13.667968-5.175782 18.890624.046874.003907 0 .007813.003907.007813.007813.003906 0 .007813.003906.011719.007813 5.21875 5.222656 5.21875 13.714843 0 18.9375l-101.808594 101.804687c-11.816406 11.816406-27.527344 18.324219-44.242188 18.328125-.003906 0-.003906 0-.011718 0h-32.125c-3.980469 0-7.796875 1.578125-10.605469 4.394531l-96.402344 96.398438c-5.855469 5.855469-5.855469 15.355469 0 21.210937 5.859375 5.863282 15.359375 5.859375 21.214844 0l92.007813-92.003906h19.703124l92.007813 92.003906c5.859375 5.859375 15.359375 5.859375 21.214844 0 5.855469-5.855468 5.855469-15.351562 0-21.210937l-76.074219-76.070313c12.839844-4.539062 24.613281-11.921875 34.527344-21.835937l79.140625-79.140625 69.726562 69.726562c5.855469 5.859375 15.355469 5.855469 21.210938 0 5.859375-5.859375 5.859375-15.355468 0-21.214844zm-238.5-292.472656 13.882812 13.878906-26.988281 26.988282-22.878906-22.878906zm-148.21875 208.113282c-.019531.019531-.039063.039062-.058594.058593-5.191406 5.148438-13.632813 5.226563-18.898437-.039062l-8.046876-8.050781c-5.230468-5.230469-5.238281-13.699219-.003906-18.9375.003906-.003907.007813-.007813.011719-.007813 0-.003906.003906-.007813.007813-.007813 5.230468-5.230468 13.699218-5.238281 18.933593-.003906l8.054688 8.050782c5.230469 5.230468 5.234375 13.703124 0 18.9375zm40.164062-40.164063c-.003906.003906-.011719.011719-.015625.015625-5.230468 5.230469-13.699218 5.238281-18.9375 0l-24.117187-24.117188c-5.21875-5.21875-5.226563-13.644531-.0625-18.875.027343-.023437.054687-.050781.082031-.078124 5.226562-5.230469 13.695312-5.234376 18.933594 0l24.117187 24.117187c5.230469 5.230469 5.238281 13.699219 0 18.9375zm40.167969-40.167969c-.003906.003906-.003906.003906-.007812.007813-.003907.003906-.007813.007812-.011719.007812-5.21875 5.222657-13.714844 5.222657-18.933594 0l-40.1875-40.183593c-5.230469-5.230469-5.234375-13.699219 0-18.933594.007813-.007813.011719-.011719.019531-.019532 5.214844-5.214843 13.699219-5.21875 18.921875-.011718l40.199219 40.195312v.003906c5.222656 5.222657 5.21875 13.714844 0 18.933594zm40.167969-40.167968c-.003907.003906-.007813.007812-.011719.011718-.003906 0-.003906.003906-.007812.007813-5.230469 5.230469-13.699219 5.234375-18.9375 0l-48.214844-48.21875c-5.234375-5.230469-5.222656-13.671875-.039063-18.898438.019531-.019531.039063-.035156.058594-.054687 5.226563-5.230469 13.695313-5.238282 18.933594 0l48.214843 48.214844c5.234376 5.230468 5.238282 13.703124.003907 18.9375zm0 0"/></svg>
                            </div>
                          </div>
                          <p class="title" v-html="defaultIconThree"></p>
                        </div>
                      </div>
                      <div class="body_footer">
                        <p class="title" v-html="defaultFooter"></p>
                        <div class="featured-list">
                          <div>
                            <div class="logo">
                              <div class="logo_1"></div>
                            </div>
                            <div class="logo">
                              <div class="logo_2"></div>
                            </div>
                            <div class="logo">
                              <div class="logo_3"></div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </template>

                  </div>
                </template>
              </transition>

            </div>
          </div>

        </div>
      </div>
    </div>

  </div>
</template>

<script>
import content from '@/translations/content'
import VueRecaptcha from 'vue-recaptcha'
import axios from 'axios'

export default {
  name: 'app',
  mixins: [content],
  components: {
    VueRecaptcha
  },
  data () {
    return {
      // State
      enabled: false,
      popupCloseCountdown: 7,
      closeInterval: '',
      // Form
      name: '',
      email: '',
      tel: '',
      description: '',
      rodo: false,
      errors: {
        name: false,
        email: false,
        tel: false,
        description: false,
        rodo: false,
        captcha: false
      },
      reCaptchaVerified: false,
      // API
      sending: false,
      success: false,
      errored: false,
      content: {},
      // GTM
      actual_page: window.location.href,
      estimate_form_button_clicked: ''
    }
  },
  watch: {
    enabled (value) {
      const body = document.getElementsByTagName('body')
      if (!value) {
        this.reCaptchaVerified = false
        body[0].classList.remove('body-overflow')
      } else {
        body[0].classList.add('body-overflow')
      }
    }
  },
  methods: {
    openModal (event) {
      this.enabled = true
      this.estimate_form_button_clicked = event.target.id
      // if (offerTitle) {
      //   this.description = Drupal.t('I am interested in the @offerTitle package', { '@offerTitle': offerTitle })
      // }
    },
    closeModalOnMouse (event) {
      this.closeModal()
    },
    closeModalOnEsc (event) {
      if (event.keyCode === 27) {
        this.closeModal()
      }
    },
    closeModal () {
      if (this.success) {
        this.name = ''
        this.email = ''
        this.tel = ''
        this.description = ''
        this.rodo = false
        this.reCaptchaVerified = false
        this.sending = false
        this.errored = false
        this.errors = {
          name: false,
          email: false,
          tel: false,
          description: false,
          rodo: false,
          captcha: false
        }
        this.success = false
      }

      this.enabled = false
      this.estimate_form_button_clicked = ''
      this.popupCloseCountdown = 7
      clearInterval(this.closeInterval)
      this.closeInterval = ''
    },
    autoCloseCountdown () {
      this.closeInterval = setInterval(this.closeCountdown, 1000)
    },
    closeCountdown () {
      this.popupCloseCountdown -= 1
      if (this.popupCloseCountdown == 0) {
        clearInterval(this.closeInterval)
        this.closeInterval = ''
        setTimeout(this.closeModal, 1000)
      }
    },
    validateFields () {
      let errors = []

      if (!this.name) {
        this.name = ''
        this.errors.name = true
        errors.push('error')
      } else {
        this.errors.name = false
      }

      if (!this.validEmail(this.email)) {
        this.email = ''
        this.errors.email = true
        errors.push('error')
      } else {
        this.errors.email = false
      }

      if (this.tel && !this.validTel(this.tel)) {
        this.tel = ''
        this.errors.tel = true
        errors.push('error')
      } else {
        this.errors.tel = false
      }

      if (!this.description) {
        this.description = ''
        this.errors.description = true
        errors.push('error')
      } else {
        this.errors.description = false
      }

      if (!this.rodo) {
        this.errors.rodo = true
        errors.push('error')
      } else {
        this.errors.rodo = false
      }

      if (!this.reCaptchaVerified) {
        this.errors.captcha = true
      } else {
        this.errors.captcha = false
      }

      if (errors.length === 0 && this.reCaptchaVerified) {
        this.sendForm()
      }
    },
    sendForm () {
      this.sending = true
      this.errored = false
      this.success = false

      let data = {
        name: this.name,
        email: this.email,
        description: this.description
      }

      if (this.tel) {
        data.tel = this.tel
      }

      axios
        .post('/api/v1/brief/submission', data)
        .then(response => {
          this.success = true

          // Google Tag Manager
          window.dataLayer = window.dataLayer || []
          dataLayer.push({
            page: this.actual_page,
            cta: this.estimate_form_button_clicked
          })

          this.autoCloseCountdown()
        })
        .catch(error => {
          this.errored = true
        })
        .finally(() => {
          this.sending = false
        })
    },
    validEmail (email) {
      const EMAIL_REGEX = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
      return EMAIL_REGEX.test(email)
    },
    validTel (tel) {
      const TEL_REGEX = /^[0-9-+s()]*$/
      return TEL_REGEX.test(tel)
    }
  },
  created () {
    const content = window.drupalSettings

    if (content) {
      this.content = content.brief
    } else {
      this.content = require('@/data/content.json')
    }

    const modalButtons = document.getElementsByClassName('estimation_form')

    for (let i = 0; i < modalButtons.length; i++) {
      modalButtons[i].addEventListener('click', (e) => { e.preventDefault(); this.openModal(e) })
    }

    window.addEventListener('keyup', this.closeModalOnEsc)
  },
  beforeDestroy () {
    window.removeEventListener('keyup', this.closeModalOnEsc)
  }
}
</script>

<style>
.body-overflow {
  overflow: hidden !important
}
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

.modal-estimate {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  width: 100%;
  height: 100%;
  overflow-y: auto;
  overflow-x: hidden;
}

.fade-enter-active, .fade-leave-active {
  transition: opacity .3s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}

</style>
